export enum SelfSelectEvent {
	SegmentChange = '[SelfSelectEvent] SegmentChange'
}
